import { useEffect } from "react";
import { CarTypes, Features, LocationServices, Calendar, Payments } from "../../components/components";
import { useBooking } from '../../context/contexts';
import './BookingPage.css'


const BookingPage = () => {
    const { 
        currentStep, 
        setCurrentStep, 
        selectedService,
        selectService,
        selectedCar, 
        clearSelectedCar, 
        totalPrice,
        services 
    } = useBooking();

    const steps = [
        { title: 'Vehicles', component: <CarTypes /> },
        { title: 'Services', component: <Features /> },
        { title: 'Location', component: <LocationServices /> },
        { title: 'Pick Date', component: <Calendar /> },
        { title: 'Payment', component: <Payments /> }
    ];

    useEffect(() => {
        // If car is already selected, start from landing page / features step
        if (selectedCar && currentStep === 0) {
            setCurrentStep(1);
        }
        
        // Set default service if none is selected and services are loaded
        if (!selectedService && services?.length > 0) {
            // Find the exterior cleaning service
            const exteriorService = services.find(service => 
                service.name.toLowerCase().includes('exterior')
            );
            if (exteriorService) {
                selectService(exteriorService);
            }
        }
    }, [selectedCar, currentStep, selectedService, services, setCurrentStep, selectService]);

    const handleNext = () => {
        setCurrentStep((prev) => Math.min(prev + 1, steps.length - 1));
    };

    const handlePrev = () => {
        // If we're going back from the features step to car selection
        if (currentStep === 1) {
            clearSelectedCar(); // Clear the selected car
        }
        setCurrentStep((prev) => Math.max(prev - 1, 0));
    };

    return (
        <div className="booking-container">
            
            <div className="stepper">
                {steps.map((step, index) => (
                    <div 
                        key={index} 
                        className={`step ${index === currentStep ? 'active' : ''} 
                            ${index < currentStep ? 'completed' : ''}`}
                    >
                        <div className="step-number">{index + 1}</div>
                        <div className="step-title">{step.title}</div>
                    </div>
                ))}
            </div>

            <div className="step-content">
                {steps[currentStep].component}
            </div>

            <div className="booking-header" style={{marginBottom: '25px'}}>
                <div className="total-price-display">
                    Total: ${totalPrice}
                </div>
            </div>

            <div className="navigation-buttons">
                <button 
                    onClick={handlePrev} 
                    className={`prev-button ${currentStep === 0 ? 'disabled' : ''}`}
                    disabled={currentStep === 0}
                >
                    Previous
                </button>
                <button 
                    onClick={handleNext}
                    className={`next-button ${currentStep === steps.length - 1 ? 'disabled' : ''}`}
                    disabled={currentStep === steps.length - 1}
                >
                    {currentStep === steps.length - 1 ? 'Finish' : 'Next'}
                </button>
            </div>
        </div>
    )
}

export default BookingPage;